// SPView.tsx
import React, { HTMLProps,ReactNode } from "react";

interface VmViewProps extends HTMLProps<HTMLDivElement> {
  children?: ReactNode;
}

const VmView: React.FC<VmViewProps> = ({ children, ...props }) => {
  return <div {...props}>{children}</div>;
};

export default VmView;
